module.exports = __webpack_public_path__ + "static/img/new-02.d1a7a9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-02.jpg
// module id = hh22
// module chunks = 0